import {
  SAVE_DELIVERY_PICKUP_TIME,
  RESET_TO_INITIAL_STATE,
  DISABLE_PROMSIE_SLOT,
} from "../actions/actionTypes";
import moment from "moment";

const initialState = {
  siteOpened: moment().format("YYYY-MM-DD HH:mm:ss"),

  isGift: false,
  gift_name: null,
  gift_message: null,
  gift_recipient_number: null,
  gift_link: null,

  call_recipient: true,

  send_gift_anonymously: false,
  unknown_location: false,
  gift_wrapping: false,

  special_remarks: "",
  special_remarks_file_url: null,
  special_remarks_file_name: null,
  src: "web",

  last_waiter_request: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "ENABLE_IS_GIFT":
      return { ...state, isGift: payload };
    case "SET_GIFT_DETAILS":
      return {
        ...state,
        gift_name: payload.name,
        gift_message: payload.message,
        gift_recipient_number: payload.number,
        gift_link: payload.link,
        send_gift_anonymously: payload.anonymous,
        call_recipient: payload.call_recipient,
        gift_wrapping: payload.gift_wrapping,
      };
    case "SET_UNKNOWN_LOCATION":
      return { ...state, unknown_location: payload };
    case "SET_SPECIAL_REMARKS":
      return {
        ...state,
        special_remarks: payload,
      };
    case "SET_SPECIAL_REMARKS_FILES":
      return {
        ...state,
        special_remarks_file_url: payload.url,
        special_remarks_file_name: payload.name
      };
    case RESET_TO_INITIAL_STATE:
      return { ...initialState };

    case "SET_FROM_MOBILE":
      return { ...state, src: "mobile" };

    case "SET_LAST_WAITER_REQUEST":
      return { ...state, last_waiter_request: payload };
    case "SET_UNKNOWN_LOCATION":
      return { ...state, unknown_location: payload };
    case "RESET_GIFTING":
      return {
        ...state,
        isGift: false,
        gift_name: null,
        gift_message: null,
        gift_recipient_number: null,
        gift_link: null,
        send_gift_anonymously: false,
        unknown_location: false,
        call_recipient: false,
        gift_wrapping: false,
      };
    default:
      return state;
  }
};
